'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: 'kendo-buttongroup-button',
    render: function render(h) {
        return h('li', this.$slots.default);
    }
};